/* eslint-disable react/jsx-key */
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
import TrialCardItem from '../CR/TrialCardItem';
import { useEffect, useMemo, useState } from 'react';
import { STCRWrapper } from '../../components/shared/Container/Container.styles';
import useSavedTrialsResultList from '../../lib/hooks/coveo/useSavedTrialsResultList';
import savedTrialHeadlessEnginee from '../../lib/utils/coveo/savedTrialHeadlessEngine';
import Pagination from '../../components/CR/Pagination';
import { getSavedTrialsPager } from '../../lib/utils/coveo/headlessPager';
import { ITagProps } from 'components/CR/Search.type';

const ViewAllSaveTrialItems = (props: any) => {
  const theme = useTheme();
  const showFullCard = useMediaQuery(theme.breakpoints.between(960, 1154));
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down(960));

  const { state } = useSavedTrialsResultList(
    savedTrialHeadlessEnginee,
    props?.fields?.noOfRecordsPerPage?.value || 12
  );
  const [trialsList, setTrialsList] = useState<any>([]);

  const savedTrialsPager = useMemo(
    () => getSavedTrialsPager(props?.fields?.noOfRecordsPerPage?.value || 12),
    []
  );
  const {
    notYetEnrolling,
    goodMatch,
    virtual,
    enrolling,
    fontWeight,
    fontSize,
    tagFontWeight,
    favoriteButtonColor,
    lineCount,
    valueFontColor,
  } = props?.fields;

  const trialCardProps: ITagProps = {
    notYetEnrolling,
    goodMatch,
    virtual,
    enrolling,
    fontWeight,
    fontSize,
    tagFontWeight,
    favoriteButtonColor,
    lineCount,
    valueFontColor,
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTrialsList(state?.results);
    }
  }, [state]);

  const [fieldsData] = useState(() => {
    const fieldsData: any = [];
    props?.fields?.searchTrialFields?.forEach((item: any) => {
      if (item?.fields?.key?.value && item?.fields?.icon?.value && item?.fields?.label?.value) {
        fieldsData.push({
          label: item?.fields?.label,
          icon: item?.fields?.icon,
          key: item?.fields?.key,
        });
      }
    });
    return fieldsData;
  });

  const modalProps = {
    title: props?.fields?.modalTitle,
    description: props?.fields?.modalDescription,
    customButtons: props?.fields?.modalCTAButtons,
  };

  return (
    <>
      {Array.isArray(trialsList) && trialsList.length > 0 ? (
        <STCRWrapper>
          <Grid
            container
            xs={12}
            sx={{
              padding: '16px',
              boxSizing: 'border-box',
              flexWrap: 'wrap',
              background: isTabletOrMobile
                ? (theme.backgroundGradients?.backgroundGradientColor6 ?? '')
                : 'none',
              marginTop: '1rem',
            }}
            columnSpacing={1.5}
            rowSpacing={2}
          >
            {trialsList &&
              trialsList?.map((item: any, index: number) => {
                const trialCardItemData = {
                  fieldsData,
                  coveoTrialObj: item,
                };
                return (
                  <Grid
                    item
                    container
                    xs={12}
                    md={12}
                    lg={4}
                    key={index}
                    sx={{
                      minWidth: showFullCard ? '100%' : '200px',
                      marginBlock: '1rem',
                      justifyContent: 'center',
                    }}
                  >
                    <TrialCardItem
                      data={trialCardItemData}
                      modalProps={modalProps}
                      style={{
                        width: '90%',
                      }}
                      state={state}
                      tagProps={trialCardProps}
                    />
                  </Grid>
                );
              })}
          </Grid>
          <Pagination pager={savedTrialsPager} />
        </STCRWrapper>
      ) : (
        <></>
      )}
    </>
  );
};
export default ViewAllSaveTrialItems;
